import { render, staticRenderFns } from "./tutorForm.vue?vue&type=template&id=3673fcad&scoped=true"
import script from "./tutorForm.vue?vue&type=script&setup=true&lang=js"
export * from "./tutorForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./tutorForm.vue?vue&type=style&index=0&id=3673fcad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3673fcad",
  null
  
)

export default component.exports